module.exports = __webpack_public_path__ + "static/media/eSign_grey.c12cbdc0.svg";